<template>
    <div>
        <fullscreen-loading v-if="loading"/>

        <div class="row mt-3">
            <div class="col-12">
                <table class="table table-sm table-no-side-paddings table-striped">
                    <thead>
                    <tr>
                        <ordering
                            :placeholder="$t('songlibrary.title')"
                            @change="load()"
                            v-model="order"
                            field="display_name"
                            tag="th"
                        >
                            {{ $t('songlibrary.title') }}
                        </ordering>
                        <ordering
                            :placeholder="$t('songlibrary.artist')"
                            @change="load()"
                            v-model="order"
                            field="author"
                            tag="th"
                        >
                            {{ $t('songlibrary.artist') }}
                        </ordering>
                        <ordering
                            :placeholder="$t('songlibrary.album')"
                            @change="load()"
                            v-model="order"
                            field="album"
                            tag="th"
                        >
                            {{ $t('songlibrary.album') }}
                        </ordering>
                        <ordering
                            :placeholder="$t('songlibrary.duration')"
                            @change="load()"
                            v-model="order"
                            field="duration"
                            tag="th"
                        >
                            {{ $t('songlibrary.duration') }}
                        </ordering>
                        <th colspan="2"/>
                    </tr>
                    </thead>

                    <tbody>
                    <tr>
                        <td>
                            <input
                                @change="load(1)"
                                class="form-control form-control-filtering"
                                :placeholder="$t('songlibrary.title')"
                                type="text"
                                v-model="filtering.display_name"
                            />
                        </td>
                        <td>
                            <input
                                @change="load(1)"
                                class="form-control form-control-filtering"
                                :placeholder="$t('songlibrary.artist')"
                                type="text"
                                v-model="filtering.author"
                            />
                        </td>
                        <td>
                            <input
                                @change="load(1)"
                                class="form-control form-control-filtering"
                                :placeholder="$t('songlibrary.album')"
                                type="text"
                                v-model="filtering.album"
                            />
                        </td>
                        <td>
                            <input
                                @change="load(1)"
                                class="form-control form-control-filtering"
                                :placeholder="$t('songlibrary.duration')"
                                type="text"
                                v-model="filtering.duration"
                            />
                        </td>
                        <td/>
                        <td/>
                    </tr>

                    <tr v-for="song of songs.data" :key="song.id">
                        <td v-tooltip="song.display_name">
                            <div class="d-flex align-items-center">
                                <img
                                    style="width: 25px; height: 25px;"
                                    :src="getSongCover(song)"
                                    class="avatar rounded-circle float-left mr-2"
                                />
                                <span class="text-limit d-block" style="width:250px;">{{ song.display_name }}</span>
                            </div>
                        </td>
                        <td v-tooltip="song.author">
                            <span class="text-limit d-block" style="width:250px;">{{ song.author }}</span>
                        </td>
                        <td v-tooltip="song.album">
                            <span class="text-limit d-block" style="width:250px;">{{ song.album }}</span>
                        </td>
                        <td>{{ $root.minutesToTimeInput(song.duration) }}</td>
                        <td>
                            <song-player
                                :preload="'none'"
                                :src="song.public_path"
                                :song_id="song.id"
                                @music_play="changeSong"
                                :playing="song.playing"
                                :key="'song_' + song.id"
                            />
                        </td>
                        <td class="text-right">
                            <button @click="addtoBlock(song)" class="btn btn-xs btn-primary">
                                {{ $t('songlibrary.add_button') }}
                            </button>
                        </td>
                    </tr>

                    <tr v-if="songs.data.length === 0 && !loading">
                        <td colspan="7" class="no-results">
                            {{ $t('songlibrary.no_results') }}
                        </td>
                    </tr>
                    </tbody>
                </table>

                <div class="card-footer border-0">
                    <Pagination :pagination="songs" @change="load"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Pagination from "../../components/Pagination";
    import Modal from "../../components/Modal";
    import DropzoneUpload from '../../components/DropzoneUpload'
    import FullscreenLoading from '../../components/FullscreenLoading'
    import SongPlayer from '../../components/SongPlayer'
    import Ordering from "../../components/Ordering";
    import FormErrors from "../../components/FormErrors";
    import SongMixin from "../mixins/SongMixin";

    export default {

        mixins: [
            SongMixin
        ],

        props: {
            songUrl: {
                required: true,
            },
            predefinedSongs: {
                required: false,
                default: null
            }
        },

        components: {
            Pagination,
            Modal,
            DropzoneUpload,
            FullscreenLoading,
            SongPlayer,
            Ordering,
            FormErrors
        },

        data() {
            return {
                loading: false,
                songs: {
                    current_page: 1,
                    data: []
                },
                showUpload: false,

                songData: null,
                songErrors: null,

                order: 'created_at,desc',
                filtering: {
                    display_name: null,
                    author: null,
                    duration: null,
                    in_library: null,
                    album: null,
                },
            }
        },

        created() {
            if (this.predefinedSongs) {
                this.songs = this.predefinedSongs;
            } else {
                this.load(1);
            }
        },

        methods: {
            getSongCover(song) {
                if (song.cover) {
                    return song.cover_public_path;
                }

                return '/images/audio.png'
            },

            changeSong(current_song_id) {

                for (let song of this.songs.data) {
                    song.playing = (current_song_id === song.id);
                }
            },

            addtoBlock(song) {
                this.$emit('song_added', song);

                // resetting the filter options
                this.filtering = {
                    display_name: null,
                    author: null,
                    duration: null,
                    in_library: null,
                    album: null,
                }

                this.load();
            }
        }
    }

</script>
